import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';

import Api from '@barboxx/api';
import { CustomDrink } from '@barboxx/models';

interface Props {
    customDrink: CustomDrink.DetailsResponse;
}

export const CustomDrinkDeleteCard = ({ customDrink }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteCustomDrink = useMutation({
        mutationKey: ['deleteCustomDrink', customDrink.id],
        mutationFn: () =>
            Api.CustomDrinks.CustomDrink.deleteCustomDrink(customDrink),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this custom drink!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Custom Drink',
            }
        );

        if (!deleteConfirmed) {
            return;
        }

        mutateDeleteCustomDrink
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted custom drink!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show('Error Deleting custom drink!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete CustomDrink" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this custom drink and
                        all associated Products with it?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
